import { Directive, HostListener } from '@angular/core';
import { LinkService } from '../services/link.service';

@Directive({
    selector: 'a[appDigi4SchoolValidation]',
    standalone: true
})
export class Digi4SchoolValidationDirective {
    constructor(private linkService: LinkService) {
    }

    @HostListener('click', ['$event']) onLinkClick(event: Event): void {
        event.preventDefault();
        const link = (event.currentTarget as HTMLAnchorElement).href;
        this.linkService.checkDigi4SchoolRedirect(link);
    }
}
